<template>
    <div id="app">
        
        <app-header v-if="showHeader"></app-header>
      
        <div class="rental-sidebar-right" :class="sidebarToggle ? '' : 'toggled-2'">
            <sidebar v-if="showHeader"></sidebar>
            <!-- <div id="loaderDiv" :class="`loader${loaderClass}`"></div> -->
            <transition name="fade" mode="out-in">
                <router-view :key = "$route.path" ></router-view>
            </transition>
        </div>
    </div>
</template>

<script>
    
    require("@babel/polyfill");
    // import Header from '@/components/Header';
    // import Sidebar from '@/components/Sidebar';
    import EventBus from "@/components/event-bus";
    export default {
        
        components: {
            // 'app-header':Header,
            // 'sidebar':Sidebar
            appHeader: () => import('@/components/Header'),
            sidebar: () => import('@/components/Sidebar'),
        },
        name: 'App',
        metaInfo: {
            // if no subcomponents specify a metaInfo.title, this title will be used
            title: process.env.COPYRIGHT_NAME,
            // all titles will be injected into this template
            titleTemplate:'%s'
        },
        data: () => ({
            showHeader:true,
            sidebarToggle: false
        }),
        created() {
            // Listen for the 'sidebar-toggle-event' on the event bus
            EventBus.$on('sidebar-toggle-event', this.handleSidebarToggleEvent);
        },
        beforeDestroy() {
            // Clean up the event listener to avoid memory leaks
            EventBus.$off('sidebar-toggle-event', this.handleSidebarToggleEvent);
        },
        mounted: function(){

            var path = window.location.pathname;
            var segments = path.split("/");
            var self = this;
            
            var userObj = localStorage.getItem("user_obj");
            if (userObj != null) {
                var userJson = JSON.parse(userObj);                
                if(userJson.sidebar_toggle == 1){
                    self.sidebarToggle = true;
                }else{
                    self.sidebarToggle = false;
                }
            }

            if ( window.location.pathname == "/") {
                this.showHeader = false;
                $(".rental-sidebar-right").css("padding-left","0px");
                $(".rental-sidebar-right").css("margin-top","0px");
            } else if ( window.location.pathname == "/forgotpassword" ){
                this.showHeader = false;
                $(".rental-sidebar-right").css("padding-left","0px");
                $(".rental-sidebar-right").css("margin-top","0px");
            } else if ( window.location.pathname == "/resetpassword" ){
                this.showHeader = false;
                $(".rental-sidebar-right").css("padding-left","0px");
                $(".rental-sidebar-right").css("margin-top","0px");
            } else if ( window.location.pathname == "/cpiproofreviewstatus" ){
                this.showHeader = false;
                $(".rental-sidebar-right").css("padding-left","0px");
                $(".rental-sidebar-right").css("margin-top","0px");
            } else if(segments[2] == 'load'){
                this.showHeader = false;
            }else {
                this.showHeader = true;
            }
            console.log(this.$route.name); 
            // if page is reset password than hide sidebar and header
            if ( this.$route.name == "ResetPassword" ) {
                this.showHeader = false;
                $(".rental-sidebar-right").css("padding-left","0px");
                $(".rental-sidebar-right").css("margin-top","0px");
            }

            // TO DO - Use Better Approch
            // PR - If Page is redirect to Login => Hide SideBar
            self.$root.$on('redirect_to_login',()=>{
                self.showHeader = false;
                $(".rental-sidebar-right").css("padding-left","0px");
                $(".rental-sidebar-right").css("margin-top","0px");
            });
            self.checkTranslationDone();
        },
        methods: {
            handleSidebarToggleEvent(toggleState) {                
                if(toggleState == 1){
                    this.sidebarToggle = true;
                }else{
                    this.sidebarToggle = false;
                }
            },
            async checkTranslationDone() {
                // Retrieve selected language from localStorage
                const selectedLang = localStorage.getItem('selectedLang');
                
                // Wait for the text to be fetched before continuing
                const textToCheck = await this.getTextFromPage();
                const api_key = process.env.TRANSLATE_API;
                
                // Call the Google Language Detection API
                fetch(`https://translation.googleapis.com/language/translate/v2/detect?key=${api_key}`, {
                    method: 'POST',
                    body: JSON.stringify({
                        q: textToCheck
                    }),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                .then(response => response.json())
                .then(data => {
                    const detectedLang = data.data.detections[0][0].language;
                    // Compare the selected language and the detected language
                    if (selectedLang !== detectedLang) {
                        EventBus.$emit('translate-lang-event', selectedLang);
                    }
                })
                .catch(error => {
                    console.error('Error detecting language:', error);
                });
            },

            getTextFromPage() {
                return new Promise((resolve) => {
                    setTimeout(() => {
                        const element = document.querySelector('#publicationLink .menu-text');
                        resolve(element ? element.innerText : '');
                    }, 100);
                });
            }
        }
    }

</script>
<style scoped>
   .fade-enter-active{
        transition: opacity 2s;
    }
    .fade-leave-active {
        opacity: 0;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>


// WEBPACK FOOTER //
// src/App.vue